import React from 'react';
import { useSnackbar } from 'notistack';
import CustomSnackbarContent, {
  CustomSnackbarVariant
} from 'src/components/Snackbar/CustomSnackbar';

let useSnackbarRef: any;

export const SnackbarUtils = {
  success(msg: string, duration = 4000) {
    this.toast(msg, 'success', duration);
  },
  error(msg: string, duration = 4000) {
    this.toast(msg, 'error', duration);
  },
  warning(msg: string, duration = 4000) {
    this.toast(msg, 'warning', duration);
  },
  info(msg: string, duration = 4000) {
    this.toast(msg, 'info', duration);
  },
  toast(msg: string, variant: string = 'default', duration = 4000) {
    useSnackbarRef?.enqueueSnackbar(msg, {
      variant,
      autoHideDuration: duration
    });
  }
};

// Permite acceder al ref global de notistack (enqueueSnackbar/closeSnackbar)
export const getSnackbarRef = () => useSnackbarRef;

const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();

  // Wrap global enqueueSnackbar to aplicar contenido y posición por defecto (sin forzar persist)
  if (useSnackbarRef && (useSnackbarRef as any).__qpWrapped !== true) {
    const originalEnqueue = useSnackbarRef.enqueueSnackbar;
    (useSnackbarRef as any).__qpWrapped = true;
    useSnackbarRef.enqueueSnackbar = (message: string, options?: any) => {
      const normalizeVariant = (v?: string): CustomSnackbarVariant => {
        if (v === 'error' || v === 'warning' || v === 'success')
          return v as CustomSnackbarVariant;
        return 'success';
      };

      const variant = normalizeVariant(options?.variant);
      const content = options?.content
        ? options.content
        : (k: any) =>
            React.createElement(CustomSnackbarContent as any, {
              message: String(message),
              variant,
              onClose: () => useSnackbarRef.closeSnackbar(k)
            });

      return originalEnqueue(message, {
        ...options,
        variant,
        content,
        anchorOrigin: { vertical: 'top', horizontal: 'right' }
        // No forzar persist ni autoHideDuration: dejar que Provider/opciones lo controlen
      });
    };
  }
  return null;
};

export default SnackbarUtilsConfigurator;
